export const flatpickrFixEventsPlugin = config => fp => {
    const handleKeydown = event => {
        const { inputFrom, inputTo } = config;
        const { target } = event;
        if (inputFrom === target || inputTo === target) {
            if (event.code === 'Enter') {
                fp.setDate([inputFrom.value, inputTo && inputTo.value], true, fp.config.dateFormat);
                event.stopPropagation();
            }
            else if (event.code === 'ArrowLeft' || event.code === 'ArrowRight') {
                event.stopPropagation();
            }
            else if (event.code === 'ArrowDown') {
                event.preventDefault();
                fp.open();
            }
        }
    };
    const release = () => {
        const { inputFrom, inputTo } = config;
        if (inputTo) {
            inputTo.removeEventListener('keydown', handleKeydown, true);
        }
        inputFrom.removeEventListener('keydown', handleKeydown, true);
    };
    const init = () => {
        release();
        const { inputFrom, inputTo } = config;
        inputFrom.addEventListener('keydown', handleKeydown, true);
        if (inputTo) {
            inputTo.addEventListener('keydown', handleKeydown, true);
        }
    };
    const register = () => {
        fp.loadedPlugins.push('flatpickrFixEventsPlugin');
    };
    return {
        onReady: [register, init],
        onDestroy: [release],
    };
};
//# sourceMappingURL=fixEvents.js.map